"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var makeActionChecker = function makeActionChecker(type) {
    return function (action) {
        return action && action.type === type;
    };
};

exports.default = makeActionChecker;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/utils/utils.js
// module id = 264
// module chunks = 0